import type { UseFormReturn } from 'react-hook-form';
import { Labeled } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IBadgesFormValues } from './BadgesForm';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';
import { UserBadgesSelector } from '~/components/organisms/fields/UserBadgesSelector';

export type IBadgesFormMainSectionProps = IContainerProps & {
  form: UseFormReturn<IBadgesFormValues>;
  appId: string;
};

export const BadgesFormMainSection: React.FC<IBadgesFormMainSectionProps> = (
  props,
) => {
  const { sx, form, appId } = props;
  const { t } = useTranslation();

  return (
    <FormSection sx={sx}>
      <Labeled
        label={t('BadgesFormMainSection.fields.badgeIds.label')}
        required
      >
        <FormField
          name="badgeIds"
          control={form.control}
          as={UserBadgesSelector}
          forwardError
          emptyValue={[]}
          appId={appId}
        />
      </Labeled>
    </FormSection>
  );
};
